import { oneOf, shape, string } from "prop-types"

import { uuid } from "../uuid"

export const horizontalSign = shape({
    uuid: uuid,
    condition: oneOf([10, 20, 30]),
    content: string,
    horizontal_sign_type: string,
})